module.exports = __webpack_public_path__ + "static/media/2014_Population_totalRate.e6c89543.png";